
<template>
  <div>
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-row :gutter="20">
        <!-- 计划名称 -->

        <el-col :span="12">
          <el-form-item
            prop="jiHuaMingCheng"
            label="计划名称"
          >
            <el-input
              v-model="entityData.jiHuaMingCheng"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 计划类型 -->

        <el-col :span="12">
          <el-form-item
            prop="jiHuaLeiXingDictKey"
            label="计划类型"
          >
            <Combox
              v-model="entityData.jiHuaLeiXingDictKey"
              type-id="D36"
              :option-data="getComboxData('D36')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 计划管理单位 -->

        <el-col :span="12">
          <el-form-item
            prop="jiHuaGuanLiDanWei"
            label="计划管理单位"
          >
            <el-input
              v-model="entityData.jiHuaGuanLiDanWei"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 课题类型 -->

        <el-col :span="12">
          <el-form-item
            prop="keTiLeiXingDictKey"
            label="课题类型"
          >
            <Combox
              v-model="entityData.keTiLeiXingDictKey"
              type-id="D37"
              :option-data="getComboxData('D37')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 课题类别 -->

        <el-col :span="12">
          <el-form-item
            prop="keTiLeiBieDictKey"
            label="课题类别"
          >
            <Combox
              v-model="entityData.keTiLeiBieDictKey"
              type-id="D38"
              :option-data="getComboxData('D38')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 所属领域 -->

        <el-col :span="12">
          <el-form-item
            prop="suoShuLingYuDictKey"
            label="所属领域"
          >
            <Combox
              v-model="entityData.suoShuLingYuDictKey"
              type-id="D39"
              :option-data="getComboxData('D39')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 项目性质 -->

        <el-col :span="12">
          <el-form-item
            prop="xiangMuXingZhiDictKey"
            label="项目性质"
          >
            <Combox
              v-model="entityData.xiangMuXingZhiDictKey"
              type-id="D40"
              :option-data="getComboxData('D40')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 课题编号 -->

        <el-col :span="12">
          <el-form-item
            prop="keTiBianHao"
            label="课题编号"
          >
            <el-input
              v-model="entityData.keTiBianHao"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 课题名称 -->

        <el-col :span="12">
          <el-form-item
            prop="keTiMingCheng"
            label="课题名称"
          >
            <el-input
              v-model="entityData.keTiMingCheng"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 重点实验室研究任务 -->

        <el-col :span="12">
          <el-form-item
            prop="zhongDianRenWu"
            label="重点实验室研究任务"
          >
            <el-input
              v-model="entityData.zhongDianRenWu"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 开始时间 -->
        <el-col :span="12">
          <el-form-item
            prop="kaiShiShiJian"
            label="开始时间"
          >
            <el-date-picker
              v-model="entityData.kaiShiShiJian"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 计划结束时间 -->
        <el-col :span="12">
          <el-form-item
            prop="jiHuaJieShuShiJian"
            label="计划结束时间"
          >
            <el-date-picker
              v-model="entityData.jiHuaJieShuShiJian"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 终止时间 -->
        <el-col :span="12">
          <el-form-item
            prop="zhongZhiShiJian"
            label="终止时间"
          >
            <el-date-picker
              v-model="entityData.zhongZhiShiJian"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 延迟终止时间 -->
        <el-col :span="12">
          <el-form-item
            prop="yanChiZhongZhiShiJian"
            label="延迟终止时间"
          >
            <el-date-picker
              v-model="entityData.yanChiZhongZhiShiJian"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 计划资助经费（万元） -->

        <el-col :span="12">
          <el-form-item
            prop="jiHuaJingFei"
            label="计划资助经费（万元）"
          >
            <el-input-number
              v-model="entityData.jiHuaJingFei"
            />
          </el-form-item>
        </el-col>

        <!-- 预算经费 -->

        <el-col :span="12">
          <el-form-item
            prop="yuSuanJingFei"
            label="预算经费"
          >
            <el-input-number
              v-model="entityData.yuSuanJingFei"
            />
          </el-form-item>
        </el-col>

        <!-- 到位经费 -->

        <el-col :span="12">
          <el-form-item
            prop="daoWeiJingFei"
            label="到位经费"
          >
            <el-input-number
              v-model="entityData.daoWeiJingFei"
            />
          </el-form-item>
        </el-col>

        <!-- 姓名 -->

        <el-col :span="12">
          <el-form-item
            prop="xingMing"
            label="姓名"
          >
            <el-input
              v-model="entityData.xingMing"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 参与身份 -->

        <el-col :span="12">
          <el-form-item
            prop="canYuShenFenDictKey"
            label="参与身份"
          >
            <Combox
              v-model="entityData.canYuShenFenDictKey"
              type-id="D41"
              :option-data="getComboxData('D41')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 依托单位 -->

        <el-col :span="12">
          <el-form-item
            prop="yiTuoDanWei"
            label="依托单位"
          >
            <el-input
              v-model="entityData.yiTuoDanWei"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 所属大单位 -->

        <el-col :span="12">
          <el-form-item
            prop="suoShuDaDanWei"
            label="所属大单位"
          >
            <el-input
              v-model="entityData.suoShuDaDanWei"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 备注 -->

        <el-col :span="12">
          <el-form-item
            prop="remarks"
            label="备注"
          >
            <el-input
              v-model="entityData.remarks"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 助理 -->
        <el-col :span="12">
          <el-form-item
            prop="assitantList"
            label="助理"
          >
            <AssistEditForm
              v-model="entityData.assitantList"
              module-code="jx02"
            />
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div class="dialog-footer">
      <el-button
        v-if="ketiInfo.isFuzeren || ketiInfo.isZuli"
        type="primary"
        @click="handleSave()"
      >
        保  存
      </el-button>
    </div>
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'
import Combox from '@/views/managesystem/gz/com/Combox'
import AssistEditForm from '@/views/managesystem/gz/com/AssistEditForm.vue'
export default {
  components: {
    Combox, AssistEditForm
  },
  props: {
    // postId: { type: Number, default: null }
  },
  data() {
    return {
      entityId: null,
      entityData: {},
      allComboxData: [],
      rules: {
        jiHuaMingCheng: [
          { required: true, message: '请输入计划名称', trigger: 'change,blur' }
        ]
      },
      selectedValue: [],
      ketiInfo: {}
    }
  },
  computed: {},
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D36;D37;D38;D39;D40;D41').then(res => {
      this.allComboxData = res.data.result
    })
  },
  activated() {
    this.init()
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    /**
     * 初始化数据
     */
    init() {
      this.entityId = this.$route.params.id
      if (!this.entityId) {
        this.$router.go(-1)
        return
      }
      const path = '/api/services/app/ky02/GetEditky02?Id=' + this.entityId
      pathReq.getNoParams(path).then(res => {
        this.entityData = res.data.result.entityData
      }).then(_ => {
        pathReq.getKetiInfo('ky02', this.entityData.id).then(r => {
          this.ketiInfo = r.data.result
        })
      })
    },
    /**
     * 打开数据字典弹出框
     */
    handleAddComboxData(dictTypeId, dictTypeName) {
      this.$bus.emit('comboxData', dictTypeId, dictTypeName)
    },
    /**
     * 新增或者修改身份信息数据
     */
    handleSave() {
      this.$refs['entityData'].validate(valid => {
        if (valid) {
          const that = this
          const path = '/api/services/app/ky02/CreateOrUpdateky02'

          pathReq
            .postForm(path, { entityData: that.entityData })
            .then(res => {
              that.$message.success('保存成功')
            })
        }
      })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 84% !important;
}
</style>
